export default function Footer() {
  return (
    <footer id="contact" className="relative bg-gradient-to-br from-orange-500 via-orange-400 to-orange-300 text-white overflow-hidden">
      {/* 裝飾性波浪背景 */}
      <div className="absolute inset-0 opacity-20">
        <svg className="absolute bottom-0 left-0 w-full h-32" viewBox="0 0 1440 120" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M0 0L60 10C120 20 240 40 360 46.7C480 53 600 47 720 43.3C840 40 960 40 1080 46.7C1200 53 1320 67 1380 73.3L1440 80V120H1380C1320 120 1200 120 1080 120C960 120 840 120 720 120C600 120 480 120 360 120C240 120 120 120 60 120H0V0Z" fill="white"/>
        </svg>
      </div>

      <div className="relative max-w-7xl mx-auto px-6 lg:px-8 py-16">
        {/* 主要內容區域 */}
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          {/* 左側 Logo */}
          <div>
            <h2 className="text-5xl md:text-6xl font-bold text-white mb-2 leading-tight">
              康顧有限公司
            </h2>
            <p className="text-white/90 text-lg font-medium">
              CORE UNITY LIMITED
            </p>
          </div>

          {/* 右側聯絡資訊 */}
          <div className="space-y-4">
            {/* 地址 */}
            <div className="flex items-start space-x-3">
              <div className="w-6 h-6 flex items-center justify-center flex-shrink-0 mt-1">
                <i className="ri-map-pin-line text-xl text-white"></i>
              </div>
              <p className="text-white text-base leading-relaxed">
                香港九龍紅磡馬頭圍道39號紅磡商業中心A座12樓1213室
              </p>
            </div>

            {/* 電話 */}
            <div className="flex items-center space-x-3">
              <div className="w-6 h-6 flex items-center justify-center flex-shrink-0">
                <i className="ri-phone-line text-xl text-white"></i>
              </div>
              <a 
                href="tel:24015938" 
                className="text-white text-base hover:text-white/80 transition-colors whitespace-nowrap cursor-pointer"
              >
                2401 5938
              </a>
            </div>

            {/* 傳真 */}
            <div className="flex items-center space-x-3">
              <div className="w-6 h-6 flex items-center justify-center flex-shrink-0">
                <i className="ri-printer-line text-xl text-white"></i>
              </div>
              <p className="text-white text-base whitespace-nowrap">
                9200 7917
              </p>
            </div>

            {/* 電郵 */}
            <div className="flex items-center space-x-3">
              <div className="w-6 h-6 flex items-center justify-center flex-shrink-0">
                <i className="ri-mail-line text-xl text-white"></i>
              </div>
              <a 
                href="mailto:info@coreunity.com.hk" 
                className="text-white text-base hover:text-white/80 transition-colors whitespace-nowrap cursor-pointer"
              >
                info@coreunity.com.hk
              </a>
            </div>

            {/* 網址 - 藍色高亮 */}
            <div className="flex items-center space-x-3">
              <div className="w-6 h-6 flex items-center justify-center flex-shrink-0">
                <i className="ri-global-line text-xl text-white"></i>
              </div>
              <a 
                href="https://www.coreunity.com.hk" 
                target="_blank"
                rel="noopener noreferrer"
                className="text-base font-semibold bg-blue-500 text-white px-4 py-1.5 rounded-md hover:bg-blue-600 transition-colors whitespace-nowrap cursor-pointer inline-block"
              >
                www.coreunity.com.hk
              </a>
            </div>
          </div>
        </div>

        {/* 底部版權聲明 */}
        <div className="mt-12 pt-8 border-t border-white/30 flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0">
          <p className="text-white/90 text-sm">
            © 2025 康顧有限公司 Core Unity Limited. 版權所有
          </p>
        </div>
      </div>
    </footer>
  );
}